import React, { memo } from 'react';
import SVG from 'react-inlinesvg';
import classNames from 'classnames/bind';
import styles from './itemStatus.module.scss';

const conditionalStyles = classNames.bind(styles);

export default memo(function ItemStatus(props) {
    return (
        <div className={styles.container}>
            <span>{props.item}</span>
            <SVG
                cacheGetRequests
                className={conditionalStyles({
                    icon: true,
                    okStatus: props.ok,
                    errorStatus: props.error
                })}
                src="./icons/dot.svg"
            />
        </div>
    );
});
